import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import CourseCheckList from '../course-checklist';
import FormActions from '../form-actions';
import AssignmentSummaryPanel from '../assignment-summary-panel';
import { Course, SelectedAssignment } from '../../types';

interface AssignCoursesPageProps {
  currentPage: number;
  courses: Course[];
  selectedCourseIds: number[];
  onToggle: (course: Course) => void;
  onBack: () => void;
  onSave: () => void;
  assignments: SelectedAssignment[];
  loading: boolean;
}

const AssignCoursesPage = ({
  currentPage, courses, selectedCourseIds, onToggle, onBack, onSave, assignments, loading,
}: AssignCoursesPageProps) => (
  <Row className="mt-5 mb-5">
    <Col sm={12} lg={6}>
      <b>{`${currentPage}. Select the course(s) you would like to assign this Custom Assignment Set to`}</b>
      <Form className="mt-2">
        <CourseCheckList
          courses={courses}
          isChecked={(course) => selectedCourseIds.includes(course.id)}
          onToggle={onToggle}
          emptyMessage="No active courses."
        />
        <FormActions onBack={onBack} onSave={onSave} />
      </Form>
    </Col>
    <Col sm={12} lg={6}>
      <AssignmentSummaryPanel assignments={assignments} loading={loading} />
    </Col>
  </Row>
);

export default AssignCoursesPage;
